import React from 'react';
import { Countdown } from './Countdown';
import { Lock, Zap, Shield, CreditCard } from 'lucide-react';
export function FinalClose() {
  return <section className="py-16 bg-white border-t-8 border-orange-500" data-id="element-51">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-52">
        <h2 className="text-4xl font-black text-blue-900 mb-6" data-id="element-53">
          📚 LENGUA PACK
        </h2>

        <p className="text-2xl text-gray-700 font-medium mb-2" data-id="element-54">
          El próximo domingo podés seguir buscando textos en Google.
        </p>
        <p className="text-2xl text-gray-900 font-black mb-10" data-id="element-55">
          O podés tener todo resuelto desde hoy.
        </p>

        <div className="mb-10" data-id="element-56">
          <Countdown data-id="element-57" />
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-58">
          <div className="bg-blue-50 p-6 rounded-2xl border border-blue-100" data-id="element-59">
            <div className="text-blue-800 font-black text-xl mb-2" data-id="element-60">
              📘 PRIMARIA
            </div>
            <div className="text-2xl font-bold text-gray-900 mb-4" data-id="element-61">
              $16.990 ARS
            </div>
            <a href="https://profelisto.com.ar/checkouts/cn/hWNBrruWTMSbBFy3IoroPf8s/es-ar?_r=AQABKILkOZV6jUhusd1JoptenHMN36xq3W8N0q469M4rk18" className="block w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 rounded-xl" data-id="element-62">
              → QUIERO PRIMARIA
            </a>
          </div>
          <div className="bg-green-50 p-6 rounded-2xl border border-green-100" data-id="element-63">
            <div className="text-green-800 font-black text-xl mb-2" data-id="element-64">
              📗 SECUNDARIA
            </div>
            <div className="text-2xl font-bold text-gray-900 mb-4" data-id="element-65">
              $18.990 ARS
            </div>
            <a href="https://profelisto.com.ar/checkouts/cn/hWNBrs3tifceXHOjpaGeuL5u/es-ar?_r=AQABl-Vdb_HbWd-l7LXyYiRNnYdhLK-U_j4xEXp26eKOqBw" className="block w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 rounded-xl" data-id="element-66">
              → QUIERO SECUNDARIA
            </a>
          </div>
        </div>

        <div className="bg-orange-50 p-8 rounded-2xl border-2 border-orange-500 mb-10" data-id="element-67">
          <div className="text-orange-600 font-black text-2xl mb-2" data-id="element-68">
            🏆 PACK COMPLETO ⭐
          </div>
          <div className="text-4xl font-black text-gray-900 mb-6" data-id="element-69">
            $27.990 ARS
          </div>
          <a href="https://profelisto.com.ar/checkouts/cn/hWNBrry0iBg6EvQUtdhoLqBm/es-ar?_r=AQABdA0tu10hNdCYGRT2WHKJ3MDG9F_ui6kN6rqvmCUWr1M" className="block w-full bg-orange-500 hover:bg-orange-600 text-white text-xl font-black py-4 rounded-xl shadow-lg" data-id="element-70">
            → QUIERO MI LENGUA PACK COMPLETO
          </a>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm font-bold text-gray-500 mb-16" data-id="element-71">
          <div className="flex items-center gap-2" data-id="element-72">
            <Lock className="w-4 h-4" data-id="element-73" /> 🔒 Pago 100% seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-74">
            <Zap className="w-4 h-4" data-id="element-75" /> ⚡ Acceso en 5 minutos
          </div>
          <div className="flex items-center gap-2" data-id="element-76">
            <Shield className="w-4 h-4" data-id="element-77" /> 🛡️ Garantía 7 días sin preguntas
          </div>
          <div className="flex items-center gap-2" data-id="element-78">
            <CreditCard className="w-4 h-4" data-id="element-79" /> 💳 Mercado Pago | Tarjeta de
            crédito
          </div>
        </div>

        <div className="pt-12 border-t border-gray-200" data-id="element-80">
          <h3 className="text-2xl font-black text-gray-900 mb-4" data-id="element-81">
            📚 LENGUA PACK
          </h3>
          <p className="text-gray-600 font-medium mb-2" data-id="element-82">
            El sistema de planificación N°1 para docentes de Lengua de primaria
            y secundaria en Argentina.
          </p>
          <p className="text-gray-900 font-bold mb-8" data-id="element-83">
            Porque enseñar Lengua no debería costarte todos los domingos del
            año.
          </p>
          <p className="text-sm text-gray-400" data-id="element-84">
            © LENGUA PACK — Profe Listo
            <br data-id="element-85" />
            Todos los derechos reservados
          </p>
        </div>
      </div>
    </section>;
}